import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom'
import AppWrapper from './AppWrapper';
import registerServiceWorker from './registerServiceWorker';


ReactDOM.render(
    <HashRouter>
        <AppWrapper />
    </HashRouter>,
    document.getElementById('root')
);
registerServiceWorker();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();



// WEBPACK FOOTER //
// ./src/index.js